const state = () => ({
  dialogTitle: '',
  dialogButtons: [],
  dialogHeaderType: 'navigation',
  clickBack: undefined
});

const getters = {
  dialogTitle(state) {
    return state.dialogTitle;
  },
  dialogButtons(state) {
    return state.dialogButtons;
  },
  dialogHeaderType(state) {
    return state.dialogHeaderType;
  },
  clickBack(state) {
    return state.clickBack;
  }
};

const mutations = {
  setDialogTitle(state, payload) {
    state.dialogTitle = payload;
  },
  setDialogButtons(state, payload) {
    state.dialogButtons = payload;
  },
  setClickBack(state, payload) {
    state.clickBack = payload;
  }
};

const actions = {
  setDialogTitle({ commit }, payload) {
    commit('setDialogTitle', payload);
  },
  setDialogButtons({ commit }, payload) {
    commit('setDialogButtons', payload);
  },
  setClickBack({ commit }, payload) {
    commit('setClickBack', payload);
  }
};

export const formStep = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
